import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";

export const authInitialState: {
  token?: string;
  isSandbox?: boolean;
} = {
}

const authSlice = createSlice({
  name: "authSlice",
  initialState: authInitialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setIsSandbox: (state, action: PayloadAction<boolean>) => {
      state.isSandbox = action.payload;
    },
    logout: (state) => {
      state.token = undefined;
      state.isSandbox = undefined;
    }
  }
});

export const {
  setToken,
  setIsSandbox,
  logout
} = authSlice.actions;

export default authSlice.reducer;